export default __webpack_public_path__ + "static/media/050-shopping mall.ae6b1ef8.svg";